var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfLib(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.888,
    height: 87.888,
    viewBox: "0 0 76.888 87.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_646",
    x: 13.199,
    y: 8.122,
    width: 42.367,
    height: 33.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_647",
    x: 37.566,
    y: 14.214,
    width: 20.031,
    height: 33.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_648",
    x: 15.23,
    y: 0,
    width: 38.306,
    height: 35.092,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_649",
    x: 15.78,
    y: 14.214,
    width: 37.205,
    height: 33.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_651",
    x: 44.673,
    y: 1.436,
    width: 32.214,
    height: 68.772,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_652",
    x: 11.168,
    y: 14.214,
    width: 20.031,
    height: 33.061,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_642",
    x: 21.321,
    y: 32.49,
    width: 26.122,
    height: 35.537,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_643",
    x: 17.429,
    y: 35.536,
    width: 24.314,
    height: 36.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_644",
    x: 27.023,
    y: 35.536,
    width: 24.314,
    height: 36.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_645",
    x: 15.229,
    y: 16.956,
    width: 38.306,
    height: 42.504,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_650",
    x: 0,
    y: 35.536,
    width: 68.765,
    height: 52.352,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b46608"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_582",
    "data-name": "Groupe 582",
    transform: "translate(-567 -576)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_646-2",
    "data-name": "Trac\\xE9 646",
    d: "M655.015,624h22.337a1.013,1.013,0,0,1,1.015,1.015v2.031a1.013,1.013,0,0,1-1.015,1.015H655.015A1.013,1.013,0,0,1,654,627.046v-2.031A1.013,1.013,0,0,1,655.015,624Zm0,0",
    transform: "translate(-631.8 -615.88)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_647-2",
    "data-name": "Trac\\xE9 647",
    d: "M798,664.061A2.031,2.031,0,0,0,798,660Zm0,0",
    transform: "translate(-751.43 -645.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648-2",
    "data-name": "Trac\\xE9 648",
    d: "M686.306,579.046A3.046,3.046,0,0,0,683.26,576H669.046A3.046,3.046,0,0,0,666,579.046v3.046h20.306Zm0,0",
    transform: "translate(-641.77 -576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649-2",
    "data-name": "Trac\\xE9 649",
    d: "M676.14,664.061h5.432A7.872,7.872,0,0,0,688.459,660h-19.2a7.872,7.872,0,0,0,6.886,4.061Zm0,0",
    transform: "translate(-644.47 -645.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_651-2",
    "data-name": "Trac\\xE9 651",
    d: "M849.518,597.485l4.7-3.755v-6.2l-3.046-3.046v3.641a1.015,1.015,0,0,1-.3.718l-2.031,2.031a1.016,1.016,0,0,1-.718.3h-2.031a1.016,1.016,0,0,1-.718-.3l-2.031-2.031a1.015,1.015,0,0,1-.3-.718v-3.641L840,587.53v6.2l4.7,3.756a1.014,1.014,0,0,1,.381.792v12.184a1.017,1.017,0,0,1-.381.793L840,615.01v4.184a17.345,17.345,0,0,1,3.046,2.4v-.982a1.016,1.016,0,0,1,.3-.718l2.031-2.031a1.016,1.016,0,0,1,.718-.3h2.031a1.016,1.016,0,0,1,.718.3l2.031,2.031a1.016,1.016,0,0,1,.3.718v3.641l3.046-3.046v-6.2l-4.7-3.756a1.014,1.014,0,0,1-.381-.792V598.278a1.017,1.017,0,0,1,.381-.793Zm0,0",
    transform: "translate(-786.33 -583.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_652-2",
    "data-name": "Trac\\xE9 652",
    d: "M644.031,664.061V660a2.031,2.031,0,0,0,0,4.061Zm0,0",
    transform: "translate(-621.83 -645.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_642-2",
    "data-name": "Trac\\xE9 642",
    d: "M710.122,769.663V768H702v1.663l4.061,4.874Zm0,0",
    transform: "translate(-671.68 -735.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_643-2",
    "data-name": "Trac\\xE9 643",
    d: "M679.746,786l-.75,7.5,6.314-2.805L681.4,786Zm0,0",
    transform: "translate(-652.57 -750.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_644-2",
    "data-name": "Trac\\xE9 644",
    d: "M741.255,786H739.6l-3.912,4.694,6.314,2.805Zm0,0",
    transform: "translate(-699.67 -750.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_645-2",
    "data-name": "Trac\\xE9 645",
    d: "M686.306,684.626V676.2a9.912,9.912,0,0,1-7.437,3.351h-5.432A9.912,9.912,0,0,1,666,676.2v8.427a5.083,5.083,0,0,0,5.077,5.076H681.23a5.083,5.083,0,0,0,5.076-5.076Zm0,0",
    transform: "translate(-641.77 -659.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 567, 576)",
    filter: "url(#Trac\\xE9_650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650-2",
    "data-name": "Trac\\xE9 650",
    d: "M611.536,786h-.913l.9,9.036a1.016,1.016,0,0,1-1.422,1.03l-7.706-3.427V803.26h-2.031V792.639l-7.71,3.427a1.016,1.016,0,0,1-1.422-1.03l.907-9.036h-.913A15.246,15.246,0,0,0,576,801.23v8.122h10.153v-7.107h2.031v7.107h26.4v-7.107h2.031v7.107h10.153V801.23A15.246,15.246,0,0,0,611.536,786Zm-6.092,15.23h-2.031V799.2h2.031Zm0-4.061h-2.031v-2.031h2.031Zm0,0",
    transform: "translate(-567 -750.46)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfLib);
export default __webpack_public_path__ + "static/media/prof-lib.b4f33010df3b4c55f4c44c7254a9109d.svg";
export { ForwardRef as ReactComponent };